export enum VerificationButtonTypes {
  HEADER = 'header',
  ADDONS = 'addons',
  ORDER = 'order',
}
